/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PermissionKey = {
    call_record_download: 'call_record_download',
    discard_product_input: 'discard_product_input',
    read_money_flow_report: 'read_money_flow_report',
    feedback_support: 'feedback_support',
    price_upsert_permission: 'price_upsert_permission',
    callcenter_view_report: 'callcenter_view_report',
    cf_workflow_categories: 'cf_workflow_categories',
    callcenter_manager: 'callcenter_manager',
    auditor: 'auditor',
    cb_order_create_in_mn: 'cb_order_create_in_mn',
    decor_modified_notification: 'decor_modified_notification',
    create_order_notification: 'create_order_notification',
    composite_product_edit: 'composite_product_edit'
} as const;
export type PermissionKey = typeof PermissionKey[keyof typeof PermissionKey];

